import { checkUserRouteAccess } from 'sonata-static-storage/lib/helpers/user.helpers';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

// Maps URL path prefixes to the permission codes required to access them.
// A user needs at least one code to be granted access.
// Order matters: more specific routes must come before broader prefixes,
// because path checks iterate this map in insertion order.
// Routes not listed here are open by default (checkUserRouteAccess returns true
// for codes not registered in platform permissions).
// biome-ignore assist/source/useSortedKeys: Route matching relies on paths order (specific prefixes first).
const ROUTE_PERMISSION_MAP: Record<string, string[]> = {
  '/contextSystem': ['myContextBuilder'],
  '/insights': ['MyNewInsights', 'MyBusinessInsights'],
  '/reporting/doohReport': ['doohReporting'],
  '/reporting': ['reporting']
};

function getPermissionCodesForPath(pathname: string): string[] | null {
  for (const [prefix, codes] of Object.entries(ROUTE_PERMISSION_MAP)) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
      return codes;
    }
  }

  return null;
}

export function hasRoutePermission(pathname: string, user?: UserInterface, userRoles?: UserRoleInterface[]): boolean {
  if (!user || !userRoles) {
    return false;
  }
  const codes = getPermissionCodesForPath(pathname);
  if (!codes) {
    return true;
  }

  return codes.some(code => checkUserRouteAccess(code, user, userRoles));
}
